"use client";

import Observability from "@launchdarkly/observability";
import SessionReplay from "@launchdarkly/session-replay";
import * as LDClient from "launchdarkly-js-client-sdk";
import { useEffect } from "react";

import { appVersion } from "#/config/appVersion";
import { environment } from "#/config/environment";
import { useLaunchDarkly } from "#/store/app/integrations/launchDarkly";
import { useAccount } from "#/store/wallet/account/account";

const clientSideID = process.env.NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_ID!;

export const LaunchDarkly = () => {
  const { setClient } = useLaunchDarkly();
  const { account } = useAccount();

  useEffect(() => {
    const client = LDClient.initialize(
      clientSideID,
      {
        ...(account
          ? {
              kind: "user",
              key: account,
            }
          : {
              kind: "anonymous",
              key: `${new Date().getTime()}-anonymous`,
            }),
      },
      {
        plugins: [
          new Observability({
            environment,
            consoleMethodsToRecord: ["error", "log", "info", "warn"],
            reportConsoleErrors: true,
            networkRecording: {
              enabled: true,
              recordHeadersAndBody: true,
            },
            version: appVersion,
          }),
          new SessionReplay({
            environment,
            privacySetting: "none",
            version: appVersion,
          }),
        ],
      },
    );

    setClient(client);

    return () => {
      client.close();
    };
  }, [account, setClient]);

  return null;
};
